// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"182":"component---src-templates-review-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"182":"432eaee32fe0b2f76aa7","223":"df0999f29fe0c412d476","293":"590b8207b7478e69ac9d"}[chunkId] + ".js";
};